import { render, staticRenderFns } from "./CreateAwardModal.vue?vue&type=template&id=b9ea4408&scoped=true&"
import script from "./CreateAwardModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateAwardModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateAwardModal.vue?vue&type=style&index=0&id=b9ea4408&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ea4408",
  null
  
)

export default component.exports